<template>
	<div class="btn-click" :class="data.verticalAlign ? 'br' : 'inline'">
		<div v-if="data.showHover">
			<el-tooltip
				v-for="btn in btnClickEvent"
				:key="btn.id"
				class="item"
				effect="dark"
				:content="btn.hoverContent"
				placement="top"
			>
				<el-button
					@click="btnClick(btn, scope.row)"
					:type="btn.style ? btn.style : data.style"
					:icon="btn.icon"
					size="mini"
					v-bind="data"
					>{{ btn.text }}
				</el-button>
			</el-tooltip>
		</div>

		<div class="noTooltip" v-if="!data.showHover" style="text-alig: left">
			<el-button
				v-for="btn in btnClickEvent"
				:key="btn.index"
				@click="btnClick(btn, scope.row)"
				:type="data.style"
				:style="[btn.style]"
				:icon="btn.icon"
				size="mini"
				v-bind="btn"
				:loading="loading"
				>{{ btn.text }}
			</el-button>
		</div>
		<div v-if="placeholder">-</div>
	</div>
</template>
<script>
import _ from 'lodash';
import filters from '@/mixins/filters';

export default {
	name: 'btn-click',
	props: ['tableData', 'scope'],
	mixins: [filters],
	data() {
		return {
			data: _.cloneDeep(this.tableData),
			loading: false,
		};
	},
	computed: {
		placeholder() {
			return this.btnClickEvent && this.btnClickEvent.length === 0;
		},
		btnClickEvent() {
			let btnList = [];

			if (typeof this.data.bind === 'function') {
				btnList = this.data.bind(this.scope.row);
			} else {
				btnList = this.data.bind || [];
			}
			return btnList.filter(item => !item.showButton || item.showButton(this.scope.row));
		},
	},
	methods: {
		btnClick(btn, row) {
			this.loading = btn.loading;
			if (btn.trigger) {
				btn.trigger(Object.assign({}, row), this);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.btn-click {
	display: flex;
	// justify-content: space-around;

	.noTooltip {
		display: flex; /* 使用弹性布局 */
		flex-wrap: wrap; /* 自动换行 */
		column-gap: 10px; /* 设置容器间距 */

		.el-button {
			margin-left: 0px;
		}
	}
}

.br {
	flex-direction: column;
}
</style>
